import { FetchError } from "../utils/errors.ts";

export function throwErrors<T>(response: Response, data?: T, error?: unknown): asserts data is NonNullable<T> {
  if (error) {
    throw new FetchError(response.status, error as string);
  }

  if (data == undefined) {
    throw new FetchError(response.status, "No data has been returned from the server");
  }
}
